import { TurboMount } from "turbo-mount";
import { registerComponent } from "turbo-mount/react";
import MultiDomainSearch from "~/react/components/multi_domain_search.tsx";
import OperationsPanel from "~/react/components/operations-panel.tsx";
import LeadLookalikes from "~/react/components/lead_lookalikes.tsx";
import DomainSearch from "~/react/components/domain_search.tsx";
import DomainSidepanelEmails from "~/react/components/domain_sidepanel_emails.tsx";
import Dashboard from "~/react/components/dashboard.tsx";
import DiscoverFilters from "~/react/components/discover_filters.tsx";

const turboMount = new TurboMount();

registerComponent(turboMount, "MultiDomainSearch", MultiDomainSearch);
registerComponent(turboMount, "OperationsPanel", OperationsPanel);
registerComponent(turboMount, "LeadLookalikes", LeadLookalikes);
registerComponent(turboMount, "DomainSearch", DomainSearch);
registerComponent(turboMount, "DomainSidepanelEmails", DomainSidepanelEmails);
registerComponent(turboMount, "Dashboard", Dashboard);
registerComponent(turboMount, "DiscoverFilters", DiscoverFilters);
// to register a component use:
// registerComponent(turboMount, "Hello", Hello); // where Hello is the imported the component

// to override the default controller use:
// registerComponent(turboMount, "Hello", Hello, HelloController); // where HelloController is a Stimulus controller extended from TurboMountController

// If you want to automatically register components use:
// import { registerComponents } from "turbo-mount/registerComponents/react";
// const controllers = import.meta.glob("/controllers/**/*_controller.js", { eager: true });
// const components = import.meta.glob("/components/**/*.jsx", { eager: true });
// registerComponents({ turboMount, components, controllers });
